// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"e2236640","269":"f32f6d3e","486":"0bfb80b4","495":"00572a57","886":"689b52e0","925":"e28be470","959":"03522b2b"}[chunkId] + ".chunk.css";
};